module.exports = __webpack_public_path__ + "static/come-back-later-e4fe3ceb2a277598c5e0ea969f06037f.svg";